import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { JobScreenGalleryComponent } from '../../components/job-control/job-screen-gallery.component';
import { TaskStepRatingComponent } from '../../components/job-control/task-step-rating.component';
import { JobScreenIncidentsComponent } from '../../components/job-incidents/job-screen-incidents.component';
import { JobScreenHistoryTimelineComponent } from '../../components/job-screen-history-timeline/job-screen-history-timeline.component';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { JobScreenComponent } from '../../components/job-control/job-screen.component';
import { JobScreenSupplierFeedbackComponent } from '../../components/job-screen-supplier-feedback/job-screen-supplier-feedback.component';
import { JobScreenDelayFailuresComponent } from '../../components/job-screen-delay-failures/job-screen-delay-failures.component';
import { SiteOpeningHoursPanelComponent } from '../../components/job-control/site-opening-hours-panel.component';
import { CustomerSitesModule } from '../../components/customer-sites/customer-sites.module';
import { DeclineAdditionalChargeComponent } from '../../components/job-control/decline-additional-charge/decline-additional-charge.component';
import { RequestAdditionalInfoComponent } from '../../components/job-control/request-additional-info/request-additional-info.component';
import { JobScreenDelayFailuresTableComponent } from 'src/app/components/job-screen/common/job-screen-delay-failures/job-screen-delay-failures-table.component';
import { JobScreenVersionToggleComponent } from 'src/app/components/job-screen/common/job-screen-version-toggle/job-screen-version-toggle.component';
import { JobScreenCarryOverComponent } from '../../components/job-screen/common/job-screen-carry-over/job-screen-carry-over.component';
import { TaskSequencingEditorComponent } from '../../components/task-sequencing-editor/task-sequencing-editor.component';
import { AdditionalInternalRequestComponent } from '../../components/job-control/additional-internal-request/additional-internal-request.component';

const components = [
  JobScreenComponent,
  JobScreenHistoryTimelineComponent,
  JobScreenIncidentsComponent,
  JobScreenSupplierFeedbackComponent,
  TaskStepRatingComponent,
  JobScreenDelayFailuresComponent,
  JobScreenDelayFailuresTableComponent,
  SiteOpeningHoursPanelComponent,
  JobScreenVersionToggleComponent,
];

const standaloneComponentImports = [
  DeclineAdditionalChargeComponent,
  RequestAdditionalInfoComponent,
  AdditionalInternalRequestComponent,
  TaskSequencingEditorComponent,
];

const routes: Routes = [
  { path: '', component: JobScreenComponent, data: { title: 'Job Screen' } },
  { path: ':orderId', component: JobScreenComponent, data: { title: 'Job Screen' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class JobScreenRoutingModule {}

@NgModule({
  imports: [
    JobScreenRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
    CustomerSitesModule,
    ...standaloneComponentImports,
    JobScreenCarryOverComponent,
  ],
  declarations: [...components],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [
    JobScreenComponent,
    JobScreenDelayFailuresTableComponent,
    JobScreenVersionToggleComponent,
  ],
})
export class JobScreenModule {}
